import { Button, Stack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

interface FooterProps {
  onConfirm?: () => void;
  onCancel?: () => void;
}

const buttonTitle = {
  confirm: {
    desktop: 'cancelar ordem',
    tablet: 'Sim, cancelar ordem',
    mobile: 'Sim, cancelar ordem',
  },
  cancel: {
    desktop: 'não cancelar',
    tablet: 'não',
    mobile: 'não',
  },
};

export const Footer: React.FC<FooterProps> = ({ onCancel, onConfirm }) => {
  const device = useBreakpointValue({ base: 'mobile', sm: 'tablet', lg: 'desktop' });

  return (
    <Stack
      direction={{ base: 'column', sm: 'row' }}
      width="full"
      space={Spacing['stack.nano']}
      alignItems="center"
      justifyContent="space-between">
      <Button
        _text={{ fontWeight: Typography['fontweight.semibold'] }}
        variant="secondary"
        onPress={onCancel}
        {...(device === 'mobile' && { w: 'full' })}>
        {buttonTitle.cancel[device]}
      </Button>
      <Button
        _text={{ fontWeight: Typography['fontweight.semibold'] }}
        variant="cancelAction"
        onPress={onConfirm}
        {...(device === 'mobile' && { w: 'full' })}>
        {buttonTitle.confirm[device]}
      </Button>
    </Stack>
  );
};
